function maVagVisualizar(response) {
  let valor = '';
  const valorCambiaPanelLateral = 11;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.action) {
    const accionStore = 'setAccion';
    valor = response.action;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
module.exports.agendasEstados = function agendasEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case 'ma_vag_visualizar':
        resolve(maVagVisualizar(response));
        break;
      default:
        reject('Error');
        break;
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/modulosChatBox/agendas.js